import React from 'react';
import { useCampaigns, useAuth } from 'api';
import { Text, Button, CampaignCard, Loading, Header } from 'ui';
import "./index.css";

export default function Campaigns(props) {
  const auth = useAuth();
  const campaigns = useCampaigns(auth && auth.user.companyId);
  
  if(!campaigns) {
    return <Loading/>;
  }
  
  if(campaigns.length === 0) {
    return (
      <div className="campaigns-placeholder">
        <Header>
          <Text large light style={{flex:1}}>Campaigns</Text>
          <Button to="create" label="START A CAMPAIGN" small white style={{backgroundColor:"#00b2a8"}}/>
        </Header>
        <div className="campaigns-placeholder-body">
          <Text huge block white style={{marginBottom:24}}>Welcome to the Taptivate Campaign Manager</Text>
          <Text white block style={{marginBottom:24}}>
            Start your first campaign by clicking the button below. Here you can design and customize NFC Tags, landing pages and upload your brand images, media and logos. All for use for use in your campaigns.
          </Text>
          <Text white block style={{marginBottom:32}}>
            Not familiar with the Taptivate Platform?<br/>
            Here are some helpful articles and tips to get you started.
          </Text>
          <Button to="create" style={{backgroundColor:"white", marginBottom:40}}>
            <Text color="#243746">Start Your First Campaign</Text>
          </Button>
        </div>
      </div>
    );
  }
  
  return (
    <div className="campains">
      <Header>
        <Text large light style={{flex:1}}>Campaigns</Text>
        <Button to="create" label="START A CAMPAIGN" small white style={{backgroundColor:"#00b2a8"}}/>
      </Header>
      <div className="campaigns-grid">
        {campaigns.map(props => <CampaignCard key={props.id} {...props}/>)}
      </div>
    </div>
  );
}